module.exports = __webpack_public_path__ + "img/75582.6e17c53c.svg";